/**
 * Pull a human-readable message from axios/API errors. Handles string bodies,
 * `{ message }`, `{ error }`, and Express-style `{ errors }`.
 */
function extractServerMessage(error) {
  const data = error?.response?.data;
  if (data == null) return null;
  if (typeof data === 'string') {
    const t = data.trim();
    return t || null;
  }
  if (typeof data === 'object') {
    return (
      data.message ||
      data.error ||
      (typeof data.errors === 'string' ? data.errors : null) ||
      null
    );
  }
  return null;
}

function isGenericAxiosStatusMessage(msg) {
  return (
    typeof msg === 'string' &&
    /^Request failed with status code \d+$/.test(msg.trim())
  );
}

const DEFAULT_FORBIDDEN =
  "You don't have permission to view or edit this record.";

/**
 * User-facing API error text. For HTTP 403, uses a clear permission message when
 * the server sent nothing useful or only Axios’s generic status string.
 *
 * @param {unknown} error - Axios error or similar
 * @param {string} [fallback='An unexpected error occurred.'] - Non-403 default
 */
export function getApiErrorMessage(
  error,
  fallback = 'An unexpected error occurred.'
) {
  const status = error?.response?.status;
  const serverMsg = extractServerMessage(error);

  if (status === 403) {
    if (!serverMsg || isGenericAxiosStatusMessage(serverMsg)) {
      return DEFAULT_FORBIDDEN;
    }
    return serverMsg;
  }

  if (serverMsg) return serverMsg;
  const m = error?.message;
  if (m && !isGenericAxiosStatusMessage(m)) return m;
  return fallback;
}
